/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  PasswordInput,
  FunctionField,
  useShowController,
  useRedirect,
  SimpleList,
  Create,
  SimpleForm,
  useRefresh,
  SelectInput,
  Toolbar as RaToolbar,
  Button as RaButton,
  SaveButton,
  Edit,
  useInput,
  EditButton,
  AutocompleteArrayInput,
  FormDataConsumer,
  ResourceContextProvider,
} from "react-admin";
import {
  useMediaQuery,
  makeStyles,
  Slide,
  AppBar,
  Toolbar,
  Typography,
  Switch,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Checkbox,
  FormControlLabel,
  TextField as MuiTextField,
  DialogTitle,
  ListSubheader,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Portal,
  TableContainer,
  TableSortLabel,
  TablePagination,
  withStyles,
  ListItem,
  ListItemIcon,
  MenuItem,
  ListItemText,
  DialogContentText,
  CircularProgress,
  Menu,
  FormControl,
  InputLabel,
  Select,
  InputAdornment,
  List as MuiList,
} from "@material-ui/core";
import { customTheme } from "./customTheme";

import config from "./config.json";

import CustomCreateButton from "./components/CustomCreateButton";

import ScrollableTable from "./components/ScrollableTable";

import ParkingSearchSelector from "./components/ParkingSearchSelector";
import { useLocation } from "react-router-dom";
import CustomPagination from "./components/CustomPagination";
import SaveIcon from "@material-ui/icons/Save";

import notify from "./components/CustomUseNotify";
import CustomSearch from "./components/CustomSearch";

const useStyles = makeStyles({
  root: {
      width: '100%',
      maxWidth: 360,
  },
  list: {
      marginBottom: 0,
  },
  parkingSelectorContainer: {
      display: "grid",
      justifyContent: "space-between",
  },
  statusIndicator: {
      display: "inline-block",
      width: 10,
      height: 10,
      borderRadius: 50,
      marginRight: 3
  },
  summaryBox: {
      borderRadius: 10,
      border: "1px solid #bbb",
      padding: "15px 20px",
      flex: 1,
      minWidth: 200,
      maxWidth: 400
  },
  mainTableCell: {
      color: `${customTheme.palette.grey[900]} !important`,
      fontWeight: 500,
  },
  listVehicleIcon: {
      width: 25,
      height: 25,
      marginRight: customTheme.spacing(1),
      verticalAlign: "middle",
  },
  chipCell: {
      textAlign: "center",
      padding: customTheme.spacing(1, 2),
      display: "inline-block",
      borderRadius: 50,
  },
  dialogPaper: {
      borderRadius: 15,
      padding: "5px 15px 15px",
      maxWidth: 350
  },
  dialogButton: {
      borderRadius: 100,
      padding: "8px 25px"
  },
  dialogPaperBig: {
      borderRadius: 15,
      padding: "5px 15px 15px",
      maxWidth: 500
  },
  columnButton: {
      color: customTheme.palette.primary.main,
      WebkitTouchCallout: "none",
      WebkitUserSelect: "none",
      KhtmlUserSelect: "none",
      MozUserSelect: "none",
      msUserSelect: "none",
      userSelect: "none",
      '&:hover': {
          cursor: 'pointer',
      },
      "&:active": {
          opacity: 0.6,
      }
  },
  menuLink: {
      textDecoration: "none",
      color: "#444",
  },
  columnLink: {
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
          cursor: 'pointer',
      }
  },
});


const CATEGORY = "APP VERSION";

const CustomUrlField = ({ record, source }) => {
  // Extract filename from the URL
  const url = record[source];
  const fileName = url.substring(url.lastIndexOf('/') + 1);

  // Handle click to open the URL in a new tab
  const handleClick = () => {
    window.open(url, '_blank');
  };

  return (
    <div style={{ cursor: 'pointer', textDecoration:"underline" }} onClick={handleClick}>
      {fileName}
    </div>
  );
};

export const OperatorAppVersion = (props) => {
  const classes = useStyles();
  const location = useLocation();
  const refresh = useRefresh();
  const isSmallDevice = useMediaQuery((theme) =>
    customTheme.breakpoints.down("xs")
  );
  const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
  let prevSearch = sessionStorage.getItem(location.pathname)
    ? JSON.parse(sessionStorage.getItem(location.pathname))
    : "";
  const [currentParking, setCurrentParking] = useState(
    prevSearch.currentParking ? prevSearch.currentParking : {}
  );
  const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");

  const zoneIds = currentParking.zone_ids
    ? currentParking.zone_ids.split(",")
    : null;
  const zoneLabels = currentParking.zones
    ? currentParking.zones.split(";")
    : null;
  const finalZones =
    zoneIds && zoneLabels
      ? zoneIds.map((id, index) => ({ id, name: zoneLabels[index] }))
      : null;
  if (finalZones)
    finalZones.sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));

  const [search, setSearch] = useState(prevSearch.inputSearch);
  let searchTypeState = ["Name"];
  const [searchTypes, setSearchTypes] = useState(
    prevSearch.type ? prevSearch.type : "Name"
  );

  

  const filter = {
    access_key: currentParking.id,
    parking_info_id: currentParking.allZones
      ? currentParking.parking_info_id
      : undefined,
  };

  const onParkingChange = (parking) => {
    setCurrentParking({ ...parking, allZones: true });
  };

  const onZoneChange = (event) => {
    setCurrentParking({
      ...currentParking,
      id: event.target.value,
      name: zoneLabels[zoneIds.findIndex((id) => id === event.target.value)],
      allZones: event.target.value === "All",
    });
  };
  

  return (
    <ResourceContextProvider value="appUpdateUrls">
      <div className={classes.list}>
        <div
          className={classes.parkingSelectorContainer}
          style={{
            gridAutoFlow: isSmallDevice ? "row" : "column",
            gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%",
            gridRowGap: isSmallDevice ? 18 : 0,
            margin: 0,
          }}
        >
          {showFilter && (
            <ParkingSearchSelector
              value={currentParking}
              onChange={onParkingChange}
              clearable={true}
              pathName={location.pathname}
            />
          )}

          {currentParking.zone_ids && currentParking.zone_ids.includes(",") && (
            <FormControl
              variant="outlined"
              style={{ marginTop: isSmallDevice ? 0 : 10 }}
            >
              <InputLabel>Zone Name</InputLabel>
              <Select
                value={currentParking.allZones ? "All" : currentParking.id}
                onChange={onZoneChange}
                label="Zone Name"
                variant="outlined"
              >
                <MenuItem value="All">All</MenuItem>
                {finalZones.map((zone, index) => (
                  <MenuItem key={index} value={zone.id}>
                    {zone.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </div>
        <div className="customStyleForDataSearchDiv">
          {sessionStorage.getItem("role") === "admin" && (
            <CustomCreateButton
              label="Upload App"
              basePath={props.basePath}
              resource={props.resource}
            />
          )}
        </div>
        <List
          basePath="/appUpdateUrls"
          style={{ marginTop: 20 }}
          title="App Version"
          bulkActionButtons={false}
          exporter={false}
          filter={filter}
          empty={false}
          pagination={<CustomPagination />}
          actions={false}
          sort={{ field: "app_version_code", order: "DESC" }}
        >
          {isSmallDevice ? (
            <SimpleList
              primaryText={(record) => record.parking_name}
              secondaryText={(record) => (
                <div>
                  {record.app_version_code && (
                    <div>
                      <span style={{ color: "#5a5a5a" }}>
                        App Version Code:{" "}
                      </span>
                      {record.app_version_code}
                    </div>
                  )}
                  {record.update_url && (
                    <div>
                      <span style={{ color: "#5a5a5a" }}>Url: </span>
                      <a href={record.update_url} target="_blank" rel="noopener noreferrer" style={{color:"#5a5a5a"}}>
                      {record.update_url}
                    </a>
                    </div>
                  )}
                </div>
              )}
              onContextMenu={(event) => event.preventDefault()}
              linkType={false}
              rowStyle={() => ({
                alignItems: "flex-start",
                borderBottom: "1px solid #18cc69",
              })}
            />
          ) : (
            <Datagrid component={ScrollableTable}>
              <TextField source="parking_name" label="Parking Name" />
              <TextField source="app_version_code" label="Version Code" />
              <CustomUrlField source="update_url" label="App Url" />
            </Datagrid>
          )}
        </List>
      </div>
    </ResourceContextProvider>
  );
};

export function OperatorAppVersionCreate(props) {
  const [loading, setLoading] = useState(false);
  const [versionName, setVersionName] = useState("");
  const [versionCode, setVersionCode] = useState("");
  const [file, setFile] = useState("")
  const redirect = useRedirect();
  const onSuccess = () => {
    notify("Element Created", "success");
    redirect(props.basePath);
  };
  const onFailure = (error) => {
    console.log(error);
    notify(error.message, "warning");
  };
  const [parking, setParking] = useState(null);

  const fileHandler = (event) => {
    const file = event.target.files[0];
    setFile(file)
    setVersionName(file.name);
};

  const handleSave = async (event) => {
    if (!versionName) return notify("Version name is required.", "warning");
    if (!versionCode) return notify("Version code is required.", "warning");
      if (!parking) return notify("Parking type is required.", "warning");
      setLoading(true)
      try {

          const getUploadUrlResponse = await fetch(`${config.HOST_NAME}/crm/getUploadUrl`, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                  RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
              },
              body: JSON.stringify({ fileName: versionName }),
          });

          if (!getUploadUrlResponse.ok) return notify("Failed to fetch presigned URL", "warning");
          const getUploadUrlResponseJson = await getUploadUrlResponse.json();
          if (!getUploadUrlResponseJson.success) return notify("Failed to get the presigned URL", "warning");
          
          const presignedUrl = getUploadUrlResponseJson.data.url;
          
          const uploadFile = await fetch(presignedUrl, {method: 'PUT', body: file, headers: {'Content-Type': file.type}});
          if (!uploadFile.ok) return notify("Failed to upload the file", "warning");

          const data = { access_key_id: parking.id, version_code: versionCode, version_name: versionName, };
          const uploadDetailsToDB = await fetch(`${config.HOST_NAME}/crm/v3/appUpdateUrls`, {
              method: "POST",
              body: JSON.stringify(data),
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                  RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
              },
          });
          const uploadDetailsToDBData = await uploadDetailsToDB.json();
          if (uploadDetailsToDBData.success) {
              notify(uploadDetailsToDBData.message, "success");
              redirect(props.basePath);
          }
          else return notify(`API call failed with status code: ${uploadDetailsToDB.message}`, "warning");

      } catch (error) {
          console.error(error);
          notify("Something went wrong", "warning");
      } finally {
          setLoading(false)
      }

  };

  const CustomToolbar = (toolbarProps) => (
    <RaToolbar {...toolbarProps}>
      <Button
        style={{ top: 13 }}
        variant="contained"
        color="primary"
        startIcon={
          loading ? (
            <CircularProgress size={25} color="inherit" />
          ) : (
            <SaveIcon />
          )
        }
        onClick={handleSave}
      >
        SAVE
      </Button>
    </RaToolbar>
  );
  return (
    <Create
      {...props}
      onFailure={onFailure}
      onSuccess={onSuccess}
      title="Upload App Version"
    >
      <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
        {/* To Disable Autofill */}
        <div style={{ gap: 10 }}>
          {
            <div
              className="formLabel-regular"
              style={{ position: "relative", top: 10, marginBottom: 15 }}
            >
              Select Parking
            </div>
          }
          <ParkingSearchSelector
            value={parking}
            onChange={setParking}
            clearable={false}
            zones={true}
            size="small"
          />
        </div>

        <div className="grid-250">
          <div
            style={{
              display: "flex",
              columnGap: 25,
              flexDirection: "column",
              marginTop: 15,
            }}
          >
            <div
              className="formLabel-regular"
              style={{ position: "relative", top: 2 }}
            >
              Upload File
            </div>
            <input
              style={{ marginTop: 20 }}
              placeholder="upload"
              type="file" // Make sure the type is "file"
              name="apk"
              accept=".apk"
              ngf-select="onChangePackageApk($files)"
              ng-model="newpackage.apk"
              ngf-accept="'.apk'"
              ngf-max-size="100MB"
              required
              ngf-model-invalid="errorFile"
              onChange={fileHandler} // Add the onChange event handler
            />
          </div>
        </div>

        <div
          className="grid-250"
          style={{ marginTop: 20, display: "flex", gap: 20 }}
        >
          <div>
            <div
              className="formLabel-regular"
              style={{ position: "relative", top: 4 }}
            >
              Version Name
            </div>
            {
              <input
                variant="outlined"
                style={{
                  position: "relative",
                  width: "100%",
                  height: "2rem",
                  borderRadius: 4,
                  marginTop: 10,
                  fontSize: "16px",
                  fontWeight: 500,
                  border: "1px solid #a8a7a5",
                }}
                value={versionName}
                disabled
              />
            }
          </div>
          <div>
            <div
              className="formLabel-regular"
              style={{ position: "relative", top: 4 }}
            >
              Version Code
            </div>
            <input
              variant="outlined"
              type="number"
              style={{
                position: "relative",
                width: "70%",
                height: "2rem",
                borderRadius: 4,
                marginTop: 10,
                fontSize: "16px",
                fontWeight: 500,
                border: "1px solid #a8a7a5",
              }}
              value={versionCode}
              onChange={(event) => {
                // Use a regular expression to allow only numeric input
                const numericValue = event.target.value.replace(/\D/g, ""); // \D matches any non-digit character
                const intValue = parseInt(numericValue, 10);
                setVersionCode(intValue);
              }}
              required
            />
          </div>
        </div>
      </SimpleForm>
    </Create>
  );
}
